import PropTypes from 'prop-types';
import React from 'react';
import styled, { useTheme } from 'styled-components';
import ButtonV2 from 'components/ButtonV2';
import { Icon, PlainButton, tokens, useIsMobile } from 'components/v3';

// Head of a full-screen phone pane (design: .ws-edit-head): title and
// subtitle, an optional ⋯ button, and Done. Sticky under the app bar.
// `headingRef` lands on the title (tabIndex -1) so the builder can move
// focus there when the pane opens.

const MoreButton = styled(PlainButton)`
  width: 40px;
  height: 40px;
  flex-shrink: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 8px;
  border: 1px solid ${(p) => p.$border};
  color: ${(p) => p.$color};
`;

const PaneHeader = ({ title, sub, onMore, moreLabel, onDone, headingRef }) => {
  const t = tokens(useTheme());
  const hasTopBar = useIsMobile(861);
  return (
    <div
      style={{
        position: 'sticky',
        top: hasTopBar ? 60 : 0,
        zIndex: 8,
        display: 'flex',
        alignItems: 'center',
        gap: 10,
        margin: '-16px -12px 16px',
        padding: '10px 12px 10px 16px',
        background: t.card,
        borderBottom: '1px solid ' + t.border,
      }}
    >
      <div style={{ flex: 1, minWidth: 0 }}>
        <h2
          ref={headingRef}
          tabIndex={-1}
          style={{
            margin: 0,
            outline: 'none',
            fontSize: 15,
            fontWeight: 700,
            color: t.text,
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            whiteSpace: 'nowrap',
          }}
        >
          {title}
        </h2>
        <div style={{ fontSize: 12, color: t.faint, marginTop: 1 }}>{sub}</div>
      </div>
      {onMore ? (
        <MoreButton
          aria-label={moreLabel}
          aria-haspopup="dialog"
          onClick={onMore}
          $border={t.border}
          $color={t.sub}
        >
          <Icon name="more-horizontal" size={18} color="currentColor" />
        </MoreButton>
      ) : null}
      <ButtonV2
        primary
        onClick={onDone}
        style={{
          width: 'auto',
          flexShrink: 0,
          minHeight: 40,
          padding: '0 18px',
        }}
      >
        Done
      </ButtonV2>
    </div>
  );
};

PaneHeader.propTypes = {
  title: PropTypes.string.isRequired,
  sub: PropTypes.string.isRequired,
  onMore: PropTypes.func,
  moreLabel: PropTypes.string,
  onDone: PropTypes.func.isRequired,
  headingRef: PropTypes.shape({ current: PropTypes.any }),
};

PaneHeader.defaultProps = {
  onMore: undefined,
  moreLabel: 'More actions',
  headingRef: undefined,
};

export default PaneHeader;
